import { useCartContext } from "app/providers/CartProvider";
import {
  OrderProduct,
  Product,
  StandardOrderProduct,
} from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { BusinessItemPricing } from "./BusinessItemPricing";

interface ProductItemPriceProps {
  product: Product | OrderProduct | StandardOrderProduct;
  className?: string;
}

const ProductItemPrice = ({ product, className }: ProductItemPriceProps) => {
  const { isSampleSale, cart, containsZakelijkProducts } = useCartContext();

  const itemPriceText = containsZakelijkProducts
    ? "Exclusief BTW en bezorging"
    : cart.isSelfAssembly
      ? "zelfmontage prijs"
      : "Inclusief btw, inmeten en montage";

  if (containsZakelijkProducts)
    return (
      <BusinessItemPricing className={className} product={product as Product} />
    );
  return (
    <div className={className}>
      <Text className="gg-text-lg gg-font-bold">
        {getFormattedPrice(product.totalPrice)}
      </Text>
      {!isSampleSale && (
        <Text className="gg-text-start gg-text-xs gg-text-dark-blue-800">
          {itemPriceText}
        </Text>
      )}
    </div>
  );
};
export default ProductItemPrice;
